"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const flow_connect_1 = require("flow-connect");
const timer_js_1 = require("./timer.js");
const log_js_1 = require("./log.js");
const buffer_js_1 = require("./buffer.js");
const to_array_js_1 = require("./to-array.js");
const array_index_js_1 = require("./array-index.js");
const array_source_js_1 = require("./array-source.js");
const random_js_1 = require("./random.js");
const boolean_source_js_1 = require("./boolean-source.js");
const json_source_js_1 = require("./json-source.js");
const number_source_js_1 = require("./number-source.js");
const string_source_js_1 = require("./string-source.js");
const file_source_js_1 = require("./file-source.js");
const compare_js_1 = require("./compare.js");
const property_js_1 = require("./property.js");
const sync_event_js_1 = require("./sync-event.js");
const sync_data_js_1 = require("./sync-data.js");
const delay_js_1 = require("./delay.js");
const to_vector_js_1 = require("./to-vector.js");
const number_range_js_1 = require("./number-range.js");
const global_event_js_1 = require("./global-event.js");
flow_connect_1.FlowConnect.register({ type: "node", name: "common/timer" }, timer_js_1.Timer);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/log" }, log_js_1.Log);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/buffer" }, buffer_js_1.Buffer);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/to-array" }, to_array_js_1.ToArray);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/array-index" }, array_index_js_1.ArrayIndex);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/array-source" }, array_source_js_1.ArraySource);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/random" }, random_js_1.Random);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/boolean-source" }, boolean_source_js_1.BooleanSource);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/json-source" }, json_source_js_1.JsonSource);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/number-source" }, number_source_js_1.NumberSource);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/string-source" }, string_source_js_1.StringSource);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/file-source" }, file_source_js_1.FileSource);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/compare" }, compare_js_1.Compare);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/property" }, property_js_1.Property);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/sync-event" }, sync_event_js_1.SyncEvent);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/sync-data" }, sync_data_js_1.SyncData);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/delay" }, delay_js_1.Delay);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/to-vector" }, to_vector_js_1.ToVector);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/number-range" }, number_range_js_1.NumberRange);
flow_connect_1.FlowConnect.register({ type: "node", name: "common/global-event" }, global_event_js_1.GlobalEvent);
